import LoadingOverlay from '~/components/common/LoadingOverlay.vue';
export default {
  components: {
    LoadingOverlay
  },
  layout: 'password',
  data() {
    return {
      storeURL: '',
      storeURLPath: '/download?redirect=no'
    };
  },
  head() {
    return {
      title: 'EXTRA'
    };
  },
  computed: {
    deepLink() {
      // return 'extra://url/eyAidXJsIjogImh0dHBzOi8vZXh0cmEuYXBwL3N3ZWVwc3Rha2UvMj90b2tlbj0iLCAidXJsX2FwcGVuZF9hdXRoIjogdHJ1ZSB9'
      let link;
      try {
        const {
          l
        } = this.$route.query;
        link = atob(l);
      } catch (err) {
        console.warn(err);
      }
      return link || this.storeURL;
    }
  },
  mounted() {
    this.storeURL = window.location.protocol + '//' + window.location.host + this.storeURLPath;
    this.redirect();
  },
  methods: {
    onButton() {
      this.redirect(true);
    },
    openLocation(url) {
      const a = document.createElement('a');
      a.setAttribute('href', url);
      // a.setAttribute('target', '_blank')
      a.click();
    },
    redirect(fromButton) {
      const now = new Date().valueOf();
      setTimeout(() => {
        // time stamp comaprison prevents redirecting to app store a 2nd time
        if (new Date().valueOf() - now > 100 && !fromButton) {
          // window.close()
          return;
        }
        window.location = this.storeURL;
        // this.openLocation(storeURL)
      }, 100);
      try {
        window.location = this.deepLink;
      } catch (err) {
        console.warn(err);
        window.location = this.storeURL;
      }
      // this.openLocatioxn(deepLink)
    }
  }
};